import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';   // ← ضيف ده
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.css'],
  standalone: true,                    // ← لو standalone
  imports: [CommonModule]              // ← ضيف ده
})
export class SnackbarComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<SnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: {
      message: string;
      type: 'success' | 'error' | 'warning' | 'info';
      action?: string;
    }
  ) {}
}